<template>
  <div class="row justify-content-center">
    <transition name="fade">
      <div v-if="etapa===1">
        <p>Vamos iniciar a simulação do seu plano de saúde?</p>
        <h3 align="center">Digite o seu CEP</h3>
        <b-form-input v-model="text" placeholder="00000-000" @Onchange="setText(e.value)"></b-form-input>
        <p>vamos utilizar para encontrarmos o seu Estado e Cidade</p>
        <div>
          <div class="mt-3">Ao continuar com a simulação você concorda com os termos de uso</div>
          <b-button class="btn-alianca btn-next">Continuar</b-button>
          <b-button class="btn-alianca btn-next btn-icon-next"><font-awesome-icon icon="angle-right" class="icon-arrow-right" /></b-button>
        </div>
      </div>
    </transition>
  </div>
  <!--
  <div>
    <div>
      <h1>Headline principal - H1</h1>
      <h2>Headline secundária - H2</h2>
      <h3>Titulo H3*(Figma)</h3>
      <h4>Titulo H4</h4>
      <h5>Titulo H5</h5>
      <h6>Titulo H6</h6>
    </div>  
    <div>
        <p>Botões</p>
        <div>
          <b-button>Generic</b-button>
          <b-button variant="danger">Danger</b-button>
          <b-button variant="success">Success</b-button>
          <b-button variant="primary">Primary</b-button>
        </div>
    </div>
    <div>
      <p>Input - Digite algo no input</p>
      <b-form-input v-model="text" placeholder="Valor..." @Onchange="setText(e.value)"></b-form-input>
      <small>Valor do input: {{ text }}</small>
    </div>
    <template>
    <div>
      <p>Select - Selecione algo</p>
      <b-form-select v-model="selected" :options="options"></b-form-select>
      <small><b-icon icon="exclamation-circle" style="margin-right: 5px"></b-icon> Selecionado: <strong>{{ selected }}</strong></small>
    </div>
    <div>
      <div class="mt-3">Button - Pesquisa de planos</div>
      <b-button class="btn-alianca pesquisar-planos">Pesquisar planos</b-button>
    </div>
    <div>
      <div class="mt-3">Button - Modais</div>
      <b-button class="btn-alianca btn-modais">Filtrar coberturas</b-button>
    </div>
    <div>
      <div class="mt-3">Range</div>
      <b-input-group class="mt-3">
        <b-form-input type="range" min="0" max="100"></b-form-input>
      </b-input-group>
    </div>
    <div>
      <div class="mt-3">Botão continuar</div>
      <b-button class="btn-alianca btn-next">Continuar</b-button>
      <b-button class="btn-alianca btn-next btn-icon-next"><font-awesome-icon icon="angle-right" class="icon-arrow-right" /></b-button>
    </div>
    <div>
      <div class="mt-3">Botão continuar - Clicked</div>
      <b-button class="btn-alianca btn-next btn-clicked">Continuar</b-button>
      <b-button class="btn-alianca btn-next btn-icon-next btn-clicked btn-clicked-icon"><font-awesome-icon icon="angle-right" class="icon-arrow-right" /></b-button>
    </div>
  </template>
  </div>
  -->
</template>

<script>

import buscarEnderecoAPI from "../services/buscarEnderecoAPI"

  export default {
    name: 'Components',
    components: {},
    data(){
      return {
        text: "",
        selected: null,
        options: [
          { value: null, text: 'Please select an option' },
          { value: 'a', text: 'This is First option' },
          { value: 'b', text: 'Selected Option' },
          { value: { C: '3PO' }, text: 'This is an option with object value' },
          { value: 'd', text: 'This one is disabled', disabled: true }
        ],
        etapa: 1
      }
    },
    methods: {
      setText(val){
        this.text = val
      },
      async buscarEndereco(){
          var endereco = await buscarEnderecoAPI("05204110")
          console.log(endereco)
      }
    },
    created() {
      this.buscarEndereco()
    }
  }
</script>

